/**
 * Formats a UTC date string to IST (Indian Standard Time)
 * @param {string|Date} dateString - UTC date string or Date object
 * @param {boolean} includeTime - Whether to include time in the output
 * @returns {string} Formatted date string in IST
 */
export const formatToIST = (dateString, includeTime = true) => {
  if (!dateString) return 'N/A';
  
  // Ensure the date string is treated as UTC by appending 'Z' if not present
  let utcDateString = dateString;
  if (typeof dateString === 'string' && !dateString.endsWith('Z') && !dateString.includes('+')) {
    utcDateString = dateString + 'Z';
  }
  
  const date = new Date(utcDateString);
  
  // Create formatter with IST timezone
  const formatter = new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    ...(includeTime && {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    })
  });
  
  return formatter.format(date);
};

/**
 * Formats a UTC date string to IST with custom format
 * @param {string|Date} dateString - UTC date string or Date object
 * @param {string} format - 'short' | 'long' | 'full'
 * @returns {string} Formatted date string in IST
 */
export const formatDateIST = (dateString, format = 'short') => {
  if (!dateString) return 'N/A';
  
  // Ensure the date string is treated as UTC by appending 'Z' if not present
  let utcDateString = dateString;
  if (typeof dateString === 'string' && !dateString.endsWith('Z') && !dateString.includes('+')) {
    utcDateString = dateString + 'Z';
  }
  
  const date = new Date(utcDateString);
  
  const formatOptions = {
    short: {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    },
    long: {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    },
    full: {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }
  };
  
  const formatter = new Intl.DateTimeFormat('en-IN', formatOptions[format] || formatOptions.short);
  return formatter.format(date);
};
